import { LocalizedLandingPage } from '@/pages/LocalizedLandingPage';
import { FR_CONTENT } from '@/pages/landingContent';

export function FrLandingPage() {
    return <LocalizedLandingPage route="/fr" content={FR_CONTENT} />;
}
